import {SearchCriteriaConfig} from "../../common/search-criteria/type/search-criteria.type";

export const searchCriteria: SearchCriteriaConfig[] = [
    {
        key: 'applicableFrom',
        label: 'Applicable From',
        inputType: 'date-range'
    },
];